import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
/**
 * An error boundary that raises the error to the user.
 */
export default class RaiseToUserErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError(_error) {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, _errorInfo) {
    this.props.viewState.terria.raiseErrorToUser(error, this.props.terriaErrorOptions);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}